import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import avatar from "./../../assests/avatar.jpg";
import "../../components/CSSCustom/toaster.css";
import { Link, useNavigate } from "react-router-dom";
import "../../App.css";

function UserDropDown({ profile, setIsCollapsed }) {
  const { state, logout } = useAuth();
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState("");
  const [avatarSrc, setAvatarSrc] = useState(null); // Start with null to detect initial state
  const [hasProfileLoaded, setHasProfileLoaded] = useState(false);

  useEffect(() => {
    const date = new Date();
    setCurrentDate(
      date.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
  }, []);

  // Update avatar source with proper priority handling
  useEffect(() => {
    // On first load (before profile fetch), use auth context
    if (!hasProfileLoaded && !profile) {
      setAvatarSrc(state.user?.avatar || null);
      return;
    }

    // After profile has loaded, prioritize profile data
    if (profile) {
      setHasProfileLoaded(true);
      // Explicitly handle "none" case - don't fallback here
      setAvatarSrc(profile.avatar !== undefined ? profile.avatar : null);
    }
  }, [profile, state.user, hasProfileLoaded]);

  const handleAvatarError = () => {
    setAvatarSrc(avatar); // Only fallback to default on image load error
  };

  // Get the actual avatar source to display
  const getDisplayAvatar = () => {
    if (avatarSrc === "none" || avatarSrc === null || avatarSrc === undefined) {
      return avatar;
    }
    return avatarSrc;
  };


  // Get user name with proper fallbacks
  const getUserName = () => {
    const firstName = hasProfileLoaded
      ? (profile?.first_name ?? state.user?.first_name ?? "")
      : (state.user?.first_name ?? "");

    const lastName = hasProfileLoaded
      ? (profile?.last_name ?? state.user?.last_name ?? "")
      : (state.user?.last_name ?? "");

    return `${firstName} ${lastName}`.trim() || "Guest";
  };

  return (
    <div className="dropdown d-inline-block user-dropdown">
      <button
        type="button"
        className="btn header-item waves-effect"
        id="page-header-user-dropdown"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div className="d-flex align-items-center">
          <img
            className="rounded-circle header-profile-user"
            src={getDisplayAvatar()}
            alt="User Avatar"
            onError={handleAvatarError}
          />
          <div className="u-profile">
            <p className="d-block ms-1 mb-0 text-start font-size-13">
              {getUserName()}
            </p>
            <p className="d-block mb-0 header-text ms-1 font-size-12 text-start">
              {currentDate}
            </p>
          </div>
        </div>
      </button>
      <div className="dropdown-menu dropdown-menu-end top-60px"
       style={{ minWidth: "220px" }} 
      >
        {/* <Link to="/profile" className="dropdown-item text-primary">
          <i className="fa-regular fa-user align-middle me-1 text-primary"></i>
          Profile
        </Link> */}
        {/* <Link
          to="/profile"
          className="dropdown-item text-primary"
          onClick={() => {
            if (setIsCollapsed) {
              setIsCollapsed(false); // Collapse sidebar
            }
            // Also reset any other necessary states here if needed
          }}
        >
          <i className="fa-regular fa-user align-middle me-1 text-primary"></i>
          Profile
        </Link> */}
        <button className="dropdown-item text-danger" onClick={logout}>
          <i className="ri-shut-down-line align-middle me-1 text-danger"></i>
          Logout
        </button>
      </div>
    </div>
  );
}

export default UserDropDown;